import { formatDate, paidUntilTone, type PaidUntilTone } from '../lib/format.js';
import { i18n } from '@wms/shared';

const { t } = i18n;

const TONE_CLASS: Record<PaidUntilTone, string> = {
  green: 'bg-green-100 text-green-900 border-green-300 dark:bg-green-900/40 dark:text-green-100',
  amber: 'bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-900/40 dark:text-amber-100',
  red: 'bg-red-100 text-red-900 border-red-300 dark:bg-red-900/40 dark:text-red-100',
  unknown: 'bg-muted text-muted-foreground border-border',
};

export function PaidUntilChip({
  paidUntil,
  thresholdDays,
}: {
  paidUntil: string | Date | null | undefined;
  thresholdDays: number;
}) {
  const tone = paidUntilTone(paidUntil, thresholdDays);
  const text = paidUntil ? formatDate(paidUntil) : t('customer.paid_until.never');
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${TONE_CLASS[tone]}`}
      title={t(`customer.paid_until.tone.${tone}`)}
    >
      {text}
    </span>
  );
}
